import { ToolCard } from 'src/types';
import FeatureCard from './FeatureCard';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

interface CardsProps {
  cards: ToolCard[];
}

const FeatureCards = (props: CardsProps) => {
  return (
    <div
      className={ivclass(
        'sm:iv-w-[340px] md:iv-w-[690px] lg:iv-w-[1080px] xl:iv-w-[1440px]',
        'iv-mx-auto',
        'iv-mt-75',
      )}
    >
      {props.cards.map((card, index) => (
        <FeatureCard key={index} card={card} />
      ))}
    </div>
  );
};

export default FeatureCards;
